export default __webpack_public_path__ + "static/media/desktop.dbdaf9a7.jpg";